module.exports = __webpack_public_path__ + "img/32-msoffice.b652b4ed.png";